module.exports = __webpack_public_path__ + "media/images/decisionSupportTool-70010722b70751dd5915505dc3775afe.svg";